var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        staticClass: "form-control product-ids-input",
        attrs: { type: "text", disabled: _vm.disabled, readonly: "" },
        domProps: { value: _vm.displayedValue },
        on: { focus: _vm.onFocusProductIds },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline px-2",
            attrs: { disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.onFocusProductIds(!_vm.isShowDropdown)
              },
            },
          },
          [
            _c("i", {
              class: {
                "cil-chevron-bottom": !_vm.isShowDropdown,
                "cil-chevron-top": _vm.isShowDropdown,
              },
            }),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowDropdown,
            expression: "isShowDropdown",
          },
        ],
        staticClass: "position-absolute mt-2",
        staticStyle: { "z-index": "1000", width: "max-content" },
      },
      [
        _c(
          "div",
          { staticClass: "file-browser-wrapper" },
          [_c("FileBrowser")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "bg-white p-2 mt-1 border border-dark d-flex justify-content-end",
            staticStyle: { "border-radius": "20px" },
          },
          [
            _c(
              "b-button",
              {
                on: {
                  click: function ($event) {
                    _vm.isShowDropdown = false
                  },
                },
              },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "ml-2",
                attrs: { variant: "success" },
                on: { click: _vm.handleImagesSave },
              },
              [_vm._v("\n        Save\n      ")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }